import {Component} from '@angular/core';
import {DataSource} from '@angular/cdk';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';

@Component({
  selector: 'app-taxes',
  templateUrl: '../../templates/taxes/taxes.component.html'
})
export class TaxesComponent {
displayedColumns = ['userId', 'userName', 'progress', 'color'];
  exampleDatabase = new ExampleDatabase();
  dataSource: ExampleDataSource | null;

  ngOnInit() {
    this.dataSource = new ExampleDataSource(this.exampleDatabase);
  }
}

/** Constants used to fill up our data base. */
const COLORS = ['Download PDF'];
const NAMES = ['IRP5'];

export interface UserData {
  id: string;
  name: string;
  progress: string;
  color: string;
}

/** An example database that the data source uses to retrieve data for the table. */
export class ExampleDatabase {
  /** Stream that emits whenever the data has been modified. */
  dataChange: BehaviorSubject<UserData[]> = new BehaviorSubject<UserData[]>([]);
  get data(): UserData[] { return this.dataChange.value; }

  constructor() {
    // Fill up the database with 100 users.
    for (let i = 0; i < 1; i++) { this.addUser(i); }
  }

  /** Adds a new user to the database. */
  addUser(i:number) {
    const copiedData = this.data.slice();
    copiedData.push(this.createNewUser(i));
    this.dataChange.next(copiedData);
  }

  /** Builds and returns a new User. */
  private createNewUser(i:number) {
    const name =
        NAMES[i];

    return {
      id: (this.data.length + 1).toString(),
      name: name,
      progress: '2017',
      color: COLORS[0]
    };
  }
}

/**
 * Data source to provide what data should be rendered in the table. Note that the data source
 * can retrieve its data in any way. In this case, the data source is provided a reference
 * to a common data base, ExampleDatabase. It is not the data source's responsibility to manage
 * the underlying data. Instead, it only needs to take the data and send the table exactly what
 * should be rendered.
 */
export class ExampleDataSource extends DataSource<any> {
  constructor(private _exampleDatabase: ExampleDatabase) {
    super();
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<UserData[]> {
    return this._exampleDatabase.dataChange;
  }

  disconnect() {}

}



// WEBPACK FOOTER //
// /home/gideon/webbest/projects/wb-management-system/frontend/wb-management-system/src/app/assets/components/taxes/taxes.component.ts